


















import {Component, Emit, Prop, Vue} from "vue-property-decorator"
import JSONEditor from './JSONEditor.vue'
import {gMutate} from "@/services/graphql"
import {SaveDocuments, SaveDocumentsVariables} from "@dynamoit/shared/generated/SaveDocuments"
import {TablesGQL} from "@dynamoit/shared/src/queries/TablesGQL"

@Component({
    components: {JSONEditor}
})
export default class EditDocument extends Vue {

    @Prop({required: true})
    value!: any

    newValue: string = ''
    saving = false

    get show() {
        return this.value !== null
    }

    get title() {
        return this.value ? 'Edit the document' : 'Create a document'
    }

    get profile() {
        return this.$route.params.profile
    }

    get tableName() {
        return this.$route.params.tableName
    }

    get newValueIsValid() {
        if (this.newValue) {
            try {
                JSON.parse(this.newValue)
                return true
            } catch (e) {
                //
            }
        }
        return false
    }

    @Emit('input')
    close() {
        return null
    }

    @Emit('save')
    save() {}

    onNewValue(newValue: string) {
        this.newValue = newValue
    }

    async onSaveClick() {
        try {
            this.saving = true
            await gMutate<SaveDocuments, SaveDocumentsVariables>(TablesGQL.SAVE_DOCUMENTS, {
                tableName: this.tableName,
                profileId: this.profile,
                documents: [this.newValue]
            })
            this.save()
            this.close()
        } finally {
            this.newValue = ''
            this.saving = false
        }
    }

}
